import script from "./ModalWindowBase.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalWindowBase.vue?vue&type=script&setup=true&lang=js"

import "./ModalWindowBase.vue?vue&type=style&index=0&id=a030f564&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a030f564"]])

export default __exports__